import { v4 as createUuid } from 'uuid';
import reduce from 'image-blob-reduce';
import { playerPosition } from "./geolocation";
import { get, readable } from "svelte/store";
import { currentUser } from "./user";
import md5 from 'md5';
import { Emitter } from "../Model/Emitter";
import { isGameInCourse } from "./game";
import { State } from "../Model/State";
const gamePicturesCount = new State(loadGamePicturesCount());
const gamePicturesCountReadable = readable(gamePicturesCount.value, set => gamePicturesCount.subscribe(set));
gamePicturesCount.subscribe(picturesCount => {
    localStorage.setItem('game_pictures_count', `${picturesCount}`);
});
export { gamePicturesCountReadable as gamePicturesCount, };
export const pictureUploads = new Emitter();
export async function getLastPictureByLabels(labels) {
    const params = new URLSearchParams();
    params.set('offset', '0');
    params.set('limit', '1');
    for (const label of labels) {
        params.append('filters[label]', label);
    }
    const response = await fetch(`https://picture-service.echeide.es/service/pictures?${params}`);
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener las la última picture.');
    }
    const [data] = await response.json();
    if (!data) {
        return null;
    }
    return createPicture(data);
}
export async function getPicturesByLabels(labels) {
    const params = new URLSearchParams();
    for (const label of labels) {
        params.append('filters[label]', label);
    }
    const response = await fetch(`https://picture-service.echeide.es/service/pictures?${params}`);
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener las pictures.');
    }
    const content = await response.json();
    return content.map(createPicture);
}
export async function uploadPicture(file, milestoneId) {
    const playerCoordinates = get(playerPosition);
    if (!playerCoordinates) {
        throw new Error('No es posible subir una imágen sin la geolocalización del usuario.');
    }
    if (!currentUser.value) {
        throw new Error('No es posible subir una imágen sin haber iniciado la sesión.');
    }
    const pictureId = createUuid();
    const formData = new FormData();
    const labels = [
        'game-cp',
        '00000394-2e28-4d04-906f-0cb6c1f2118d',
        md5(currentUser.value.email), // Email md5 del correo del usuario
    ];
    if (milestoneId !== undefined) {
        labels.push(milestoneId);
    }
    formData.set('pictureId', pictureId);
    formData.set('pictureLabels', labels.join(','));
    formData.set('pictureMeta[coordinates]', `${playerCoordinates.lon},${playerCoordinates.lat}`);
    formData.set('pictureMeta[user_name]', currentUser.value.name);
    formData.set('pictureMeta[user_image]', currentUser.value.image);
    formData.set('file', await resize(file));
    const response = await fetch('https://picture-service.echeide.es/service/picture', {
        method: 'POST',
        body: formData
    });
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al enviar la imagen.');
    }
    addPictureToGamePicturesCount();
    pictureUploads.emit({ pictureId, milestoneId });
    return pictureId;
}
export function clearGamePicturesCount() {
    if (gamePicturesCount.value === 0) {
        return;
    }
    gamePicturesCount.set(0);
}
function addPictureToGamePicturesCount() {
    if (!isGameInCourse()) {
        return;
    }
    gamePicturesCount.set(gamePicturesCount.value + 1);
}
function loadGamePicturesCount() {
    const picturesCount = localStorage.getItem('game_pictures_count');
    if (!picturesCount) {
        return 0;
    }
    return parseInt(picturesCount);
}
function resize(file) {
    const reducer = reduce();
    return reducer.toBlob(file, {
        max: 2000
    });
}
function createPicture({ id, labels, url, meta, createdDate }) {
    return { id, labels, url, meta, createdDate: new Date(createdDate) };
}
